<template>
    <VcLayout align-center justify-center class="mainLoader">
      <VcLoader color="#0C315E"/>
    </VcLayout>
</template>

<script>
export default {
    name: 'IconsLoader',
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_i18n-mixins.scss";

.mainLoader {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

</style>
